<template lang="html">
  <div class="submit">
    <common-header></common-header>
    <div class="page ">
      <div class="wrapper-content container ">
        <div class="ibox-title col-sm-12">
            <h5 class="text-center">会员登记申请</h5>
        </div>
        <div class="box col-sm-12 row justify-content-md-center submit_box">
          <!-- <div class="col-sm-5  row"> -->
            <div class="col-sm-6 text-right align-middle">
              <img   src="../assets/info.png" alt="">
            </div>
            <div class="col-sm-6 text-left info-tip">
              <h6>信息已提交</h6>
              <h6>请耐心等待审核</h6>
            </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="form-group" style="margin: 0 auto;">
        <div class="btn btn-primary" @click="$router.push('/')">
          完成
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonHeader from './header.vue'
export default {
  data() {
    return {
    }
  },
  components: {
    commonHeader
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang="css">
.submit .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}
.submit .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}
.submit .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}
.submit .btn-primary.disabled {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}
.submit .btn-secondary {
  margin-top: 10px;
}
.submit .part {
  padding: 20px 0;
}
.submit .border {
  width: 100%;
}
.submit .box {
  width: 100%;
  padding: 150px;
  margin-left: 0;
  margin-right: 0;
}
.submit .fullScreen {
  height: 100%;
}
.submit .page-link {
  color: #33434b;
}
.submit .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}
.submit .page-link.active {
  background: #f4f4f4;
}
.submit .custom-file-label::after {
  content: "证明材料上传";
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}
.submit .custom-file-label {
  border: none;
}
.submit .red {
  color: red;
  margin: 0 5px;
}
.submit .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
}
.submit table td,
table th {
  color: #333;
}
.submit .table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none;
}
.submit .form-group {
  margin-bottom: 0;
}
.submit .upload-image {
  margin-top: 20px;
}
.submit .upload-image img {
  height: 150px;
  width: auto;
}
.submit .custom-file {
  margin-top: 0%;
}
.submit .example-img {
  height: 150px;
  width: 200px;
  border: 1px solid #33434b;
  border-radius: 5px;
  position: relative;
}
.submit .example-img:after {
  content: "+";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #33434b;
  font-size: 50px;
}
.submit .info-tip h6 {
  font-size: 20px;
  color: #33434b;
  /*padding-right: 24px;*/
  line-height: 1.5;
}
.submit .info-tip h6:first-child {
  margin-top: 30px;
}
@media only screen and (max-width: 750px) {
  .submit .box {
    padding: 20px 0 !important;
  }
  .submit_box .col-sm-6 {
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/submitCheck.vue